import { Image, Space } from "antd";
import SummaryWrapper from "../SummaryWrapper";
import React from "react";
import {
  getLabelTagInput,
  getLabelTagsArray,
  getLabelTagswithCheckbox,
  getLabelTagsWithDescription,
  getLabelTagsWithDynamicInputs,
} from "../constructTextFromValues";
import {
  cardioDiagnosisOptions,
  neuroDiagnosisOptions,
  orthoDiagnosisOptions,
  spinalCordOptions,
  sportsDiagnosisOptions,
  strokeOptions,
} from "../../Options/physioOptions";
import diagnosisIcon from "../../../../assets/doctorIcons/diagnosis.svg";
import { checkEmpty } from "../../../../helpers/utility";

const PhysioFunctionalDiagnosisSummary = ({ formData }) => {
  const filteredNeuroOptions = neuroDiagnosisOptions.filter(
    (option) =>
      !["stroke", "head_injury", "spinal_cord_injury"].includes(option.value)
  );
  const constructFunctionalDiagnosisSummaryItems = () => {
    const functionalDiagnosisSummaryItems = [];
    const diagnosis = formData?.functional_diagnosis || {};
    const pushFunctionalItem = (key, label, children) => {
      functionalDiagnosisSummaryItems.push({ key, label, children });
    };
    if (diagnosis?.cardio) {
      pushFunctionalItem(
        "1",
        "Cardio",
        <>
          {getLabelTagswithCheckbox(
            cardioDiagnosisOptions,
            "cardio",
            diagnosis
          )}
          {getLabelTagsWithDynamicInputs(diagnosis?.cardio_others)}
        </>
      );
    }
    if (diagnosis?.ortho) {
      pushFunctionalItem(
        "2",
        "Ortho",
        <>
          {getLabelTagsWithDescription(orthoDiagnosisOptions, diagnosis?.ortho)}
          {getLabelTagsWithDynamicInputs(diagnosis?.ortho?.others)}
        </>
      );
    }
    if (diagnosis?.sports) {
      pushFunctionalItem(
        "3",
        "Sports",
        <>
          {getLabelTagsWithDescription(
            sportsDiagnosisOptions,
            diagnosis?.sports
          )}
          {getLabelTagsWithDynamicInputs(diagnosis?.sports?.others)}
        </>
      );
    }
    if (diagnosis?.neuro) {
      pushFunctionalItem(
        "4",
        "Neuro",
        <>
          {diagnosis?.neuro_stroke_options?.length > 0 &&
            getLabelTagInput(
              "Stroke",
              <>
                {getLabelTagsArray(
                  strokeOptions,
                  diagnosis?.neuro_stroke_options
                )}
                {diagnosis?.neuro_stroke_description &&
                  getLabelTagInput(
                    "Others Details",
                    diagnosis?.neuro_stroke_description
                  )}
              </>
            )}
          {diagnosis?.neuro_head_injury_options?.length > 0 &&
            getLabelTagInput(
              "Head Injury",
              <>
                {getLabelTagsArray(
                  strokeOptions,
                  diagnosis?.neuro_head_injury_options
                )}
                {diagnosis?.neuro_head_injury_description &&
                  getLabelTagInput(
                    "Others Details",
                    diagnosis?.neuro_head_injury_description
                  )}
              </>
            )}
          {diagnosis?.neuro_spinal_cord_injury_options?.length > 0 &&
            getLabelTagInput(
              "Spinal Cord Injury",
              <>
                {getLabelTagsArray(
                  spinalCordOptions,
                  diagnosis?.neuro_spinal_cord_injury_options
                )}
                {diagnosis?.neuro_spinal_cord_injury_description &&
                  getLabelTagInput(
                    "Others Details",
                    diagnosis?.neuro_spinal_cord_injury_description
                  )}
              </>
            )}
          {getLabelTagswithCheckbox(filteredNeuroOptions, "neuro", diagnosis)}
          {getLabelTagsWithDynamicInputs(diagnosis?.neuro_others)}
        </>
      );
    }
    if (checkEmpty(diagnosis?.others)) {
      pushFunctionalItem(
        "5",
        "Others",
        getLabelTagsWithDynamicInputs(diagnosis?.others)
      );
    }
    return functionalDiagnosisSummaryItems;
  };
  const functionalDiagnosisSummaryItems =
    constructFunctionalDiagnosisSummaryItems();
  return (
    <SummaryWrapper
      items={functionalDiagnosisSummaryItems}
      title={
        <span style={{ fontWeight: "500", marginLeft: ".2rem" }}>
          <Space>
            <Image src={diagnosisIcon} width={18} preview={false} />
            <span style={{ fontSize: "16px", fontWeight: "normal" }}>
              Functional Diagnosis
            </span>
          </Space>
        </span>
      }
    />
  );
};

export default PhysioFunctionalDiagnosisSummary;
